(function() { window.GUID_63310227_e4bb_412a_966f_e54d6e5f61e9 = { getGuid: function() { return "63310227-e4bb-412a-966f-e54d6e5f61e9"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-teammembers",
                        callback: function (control, e) {
                            CS.Controls.CheckBox.Events.CheckboxValueChanged({
                                selector: ".team-notif-checkbox",
                                callback: (control, params) => {
                                    let teamId = control.$Control
                                        .parents(".team-notifications")
                                        .data("teamid");
                                    let isSubscribed = control.IsChecked;
                                    let data = {
                                        teamId: teamId,
                                        isSubscribed: isSubscribed,
                                    };
                                    CS.Ajax.Post($("#csurl-updateteamnotificationsubscription").val(), data, function (response) {
                                        if (response.success) {
                                            CS.Controls.Snackbar.Show({
                                                Id: "team-notifications-updated",
                                                Message: response.message,
                                                AutoHideDuration: 5000,
                                                Type: isSubscribed
                                                    ? CS.Enumeration.SnackbarType.Success
                                                    : CS.Enumeration.SnackbarType.Info,
                                                Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                                                Animation: CS.Enumeration.SnackbarAnimation.Slide,
                                            });
                                        }
                                    });
                                },
                            });
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=team-members.js.map
